export function getBudgetExpenseKind(expenseOrLabel, categoryOverride) {
  const source = typeof expenseOrLabel === 'object' && expenseOrLabel !== null ? expenseOrLabel : {}
  const category = String(categoryOverride ?? source.distribution_category ?? source.category ?? '').trim()
  const label = String(
    typeof expenseOrLabel === 'string'
      ? expenseOrLabel
      : source.expense_type ?? source.label ?? source.team ?? ''
  ).toLowerCase()

  if (category === 'tax') return 'tax'
  if (category === 'production') return 'production'
  if (category === 'non_production') return 'non-production'
  if (label.includes('налог') || label.includes('tax')) return 'tax'
  if (label.includes('непроиз')) return 'non-production'
  if (label.includes('производ') || label.includes('произв')) return 'production'
  return 'other'
}

export function getBudgetExpenseOrder(expenseOrKind) {
  const kind = ['tax', 'production', 'non-production', 'other'].includes(expenseOrKind)
    ? expenseOrKind
    : getBudgetExpenseKind(expenseOrKind)
  if (kind === 'tax') return 0
  if (kind === 'production') return 1
  if (kind === 'non-production') return 2
  return 3
}

export function getBudgetExpenseMarker(kind) {
  if (kind === 'tax') return '+'
  if (kind === 'production') return '!'
  if (kind === 'non-production') return 'x'
  return '-'
}
